import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { AppStateType } from '../../reducers'
import { selectMediaTypeGroup } from '../../selectors/mediaTypesGroups'
import { selectActiveModal } from '../../selectors/modal'
import { selectAreaWritable } from '../../selectors/auth'
import { AREA_CONSTANTS } from '../../services/auth'
import { MediaTypeGroupSettingsPage as Page } from './MediaTypeGroupSettingsPage'

const mapStateToProps = (state: AppStateType) => ({
  mediaTypeGroup: selectMediaTypeGroup(state),
  activeModal: selectActiveModal(state),
  canEditMediaTypeGroups: selectAreaWritable(state, {
    area: AREA_CONSTANTS.SETTINGS_MEDIA_TYPE_GROUP,
  }),
})

export const MediaTypeGroupSettingsPage = withRouter(
  connect(mapStateToProps)(Page)
) as React.FC<{}>
